import React from "react";
import { List, ListItem, Label } from "@patternfly/react-core";
import { Icons } from "shared/utils/Icons"; // ścieżka do Icons.js

// Opcjonalnie: mapa indywidualnych rozmiarów ikon
const ICON_SIZES = {
  PhpIcon: 21,
  HtmlIcon: 22,
  CssIcon: 22,
  JsIcon: 18,
  default: 19
};

export const SheetTypesGrid = ({ row, groupFilter }) => {
  const groupData = groupFilter
    ? Object.values(row?.groups_completed || {}).find(
        (g) => g.group_symbol === groupFilter
      )
    : null;

  const completedTypes = groupData?.completed_sheet_type || [];
  const repetitions = groupData?.repetitions || 0;
  const totalExercises = groupData?.number_of_exercises || 0;

  return (
    <List isPlain style={{ rowGap: "2px" }}>
      {(row.types || []).map((type) => {
        let color;
        let colorOutline;

        if (groupFilter && groupData) {
          const isCompleted = completedTypes.includes(type.sheet_type);

          if (repetitions > 1) {
            color = "gold";
          } else if (isCompleted && completedTypes.length <= totalExercises) {
            color = "green";
            colorOutline = "green";
          } else if (isCompleted) {
            color = "blue";
          }
        }

        const IconComponent = Icons?.[type.icon_name];
        const iconSize = ICON_SIZES[type.icon_name] || ICON_SIZES.default;

        return (
          <ListItem key={type.uid}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "60px 1fr", // stała szerokość kolumny ikon/Label
                columnGap: "8px",
                alignItems: "center",
              }}
            >
              {/* IKONA / LABEL */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                {IconComponent ? (
                  <IconComponent
                    style={{
                      width: `${iconSize}px`,
                      height: `${iconSize}px`,
                      marginRight: "4px",
                      verticalAlign: "middle",
                    }}
                  />
                ) : (
                  <Label
                    variant="outline"
                    style={{
                      fontSize: "10px",
                      padding: "0 4px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {type.sheet_type.toUpperCase()}
                  </Label>
                )}
              </div>

              {/* OPIS */}
              <div style={{ fontSize: "12px", lineHeight: "1.5" }}>
                <b>{type.short_description}</b>{" "}
                <span style={{ opacity: 0.7 }}>- {type.description}</span>
              </div>
            </div>
          </ListItem>
        );
      })}
    </List>
  );
};